import { Guarantees } from '@spotahome/ui-library';
import './HiwGuarentee.scss';

const HiwGuarentee = () => {
  return <Guarantees />;
};

export default HiwGuarentee;
